import { useEffect, useState } from "react";

const fmt = (ms) => {
  if (ms <= 0) return "Expired";
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  return h > 0 ? `${h}h ${m}m left` : `${m}m left`;
};

export default function Countdown({ to, className = "", testid }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);
  return <span className={className} data-testid={testid}>{fmt(new Date(to).getTime() - now)}</span>;
}
